import { FC } from "react";

import { ProgressSnapshotDialog } from "@/domain/progress-snapshot/components/progress-snapshot-dialog";
import { useCurrentWorkspaceContext } from "@/domain/workspace/hooks/useCurrentWorkspaceContext";

import { ClimateActionEventFeed } from "../../../components/climate-action-event-feed/climate-action-event-feed";
import { useClimateActionUIState } from "../../../hooks/use-climate-action-ui-state";
import { useCurrentClimateActionContext } from "../../../hooks/use-current-climate-action-context";

export const ClimateActionActivityTabPage: FC = () => {
  const { currentWorkspace } = useCurrentWorkspaceContext();
  const { currentClimateAction } = useCurrentClimateActionContext();

  const { isEditing } = useClimateActionUIState();
  return (
    <main className="relative place-items-stretch overflow-auto">
      <div className="mb-2 flex flex-row items-center justify-between">
        <div>Aktivität</div>
        {isEditing && <ProgressSnapshotDialog climateAction={currentClimateAction} workspace={currentWorkspace} />}
      </div>

      <div>
        <ClimateActionEventFeed workspace={currentWorkspace} climateAction={currentClimateAction} />
      </div>
    </main>
  );
};
